export const DETECT_STATUS = {
  normal: 1,
  pass: 2,
  error: 0
}

/**
 * 检测操作系统是否通过
 * @param {string} OS
 * @param {string} osVersion
 * @returns { { status: string; osTip?: string }}
 *  status: 0 不通过 1 一般 2 通过；osTip: 操作系统提示
 */
export function getOsPassInfo(OS, osVersion) {
  const result = {}
  if (OS === 'Windows') {
    const fullOsStr = OS + osVersion
    const normalArr = ['Windows7', 'Windows8', 'Windows8.1'] // 一般般
    const errorArr = [
      'Windows',
      'Windows2000',
      'WindowsXP',
      'Windows2003',
      'WindowsVista'
    ] // 不够格
    if (normalArr.indexOf(fullOsStr) >= 0) {
      result.status = DETECT_STATUS.normal
    } else if (errorArr.indexOf(fullOsStr) >= 0) {
      result.status = DETECT_STATUS.error
      result.osTip = '操作系统版本过低，请升级到要求的版本'
    } else {
      result.status = DETECT_STATUS.pass
    }
  } else if (OS === 'Mac OS') {
    const num = osVersion.split('.')
    // 一般
    if (Number(num[0]) >= 10 && Number(num[1]) < 11 && Number(num[1]) >= 9) {
      result.status = DETECT_STATUS.normal
    } else if (
      (Number(num[0]) >= 10 && Number(num[1]) >= 11) ||
      Number(num[0]) > 10
    ) {
      // 好的
      result.status = DETECT_STATUS.pass
    } else {
      // 异常的
      result.status = DETECT_STATUS.error
      result.osTip = '操作系统版本过低，请升级到要求的版本'
    }
  } else {
    result.status = DETECT_STATUS.error
    result.osTip = '操作系统暂不支持，请升级到Windows7以上版本'
  }

  return result
}

/**
 *
 * @param {string} browser
 * @param {string} browserVersion
 * @returns { { detectVersion: number; versionTip?: string }}
 *  detectVersion: 0 不通过 1 一般 2 通过；versionTip: 浏览器提示
 */
export function getBrowserPassInfo(browser, browserVersion) {
  const result = {}

  if (browser !== 'Chrome') {
    result.detectVersion = DETECT_STATUS.error
    result.versionTip = '浏览器异常'
    return result
  }
  const versionStr = browserVersion.split('/')[1]
  let version = 0
  if (versionStr) {
    version = (versionStr.split('.')[0]) || 0
  }

  if (Number(version) >= 78) {
    result.detectVersion = DETECT_STATUS.pass
  } else if (Number(version) < 78) {
    result.detectVersion = DETECT_STATUS.error
    result.versionTip = '浏览器版本过低'
  } else {
    result.detectVersion = DETECT_STATUS.normal
    result.versionTip = '浏览器版本过低'
  }

  return result
}

/**
 *
 * @param {string | number} uploadSpeed
 * @param {string | number} downloadSpeed
 * @returns { { status: number; speedTip?: string }}
 *  status: 0 不通过 1 一般 2 通过；speedTip: 网速提示
 */
export function getSpeedTestPassInfo(uploadSpeed, downloadSpeed) {
  const result = {}
  if (Number(uploadSpeed) >= 1 && Number(downloadSpeed) >= 1) {
    result.status = DETECT_STATUS.pass
  } else if (Number(uploadSpeed) < 1 || Number(downloadSpeed) < 1) {
    result.status = DETECT_STATUS.error
    result.speedTip = '网速不满足要求'
  } else {
    result.status = DETECT_STATUS.normal
    result.speedTip = '网速不满足要求'
  }

  return result
}

export function getDefaultCameraId() {
  return localStorage.getItem('defaultCameraId') || undefined
}

export function setDefaultCameraId(cameraId) {
  localStorage.setItem('defaultCameraId', cameraId)
}

/**
 *
 * @param {string} errorCode 错误码
 */
export function openMicrophoneHelpLink(errorCode) {
  const helpLink = {
    NotAllowedError: 'https://shimo.im/docs/Vtd9pXtJX3HQdcyR',
    default: 'https://shimo.im/docs/RHTP39wpYxg3xkVp'
  }

  window.open(helpLink[errorCode] || helpLink.default)
}

/**
 *
 * @param {string} errorCode 错误码
 * @returns
 */
export function getMicrophoneErrorText(errorCode) {
  const errorText = {
    NotAllowedError: '未获取到麦克风权限',
    OverConstrainedError: '麦克风被占用或者分辨率不支持',
    NotFoundError: '没有找到设备',
    NotReadableError: '麦克风被占用或者分辨率不支持',
    AbortError: '操作被中止',
    default: '麦克风录制声音听不到'
  }

  return errorText[errorCode] || errorText.default
}
/**
 *
 * @param {string} errorCode
 */
export function openCameraHelpLink(errorCode) {
  const helpLink = {
    NotAllowedError:
      'https://codemao.yuque.com/eaxnrz/cau9tm/tg6bg3u3xnm4d17y?singleDoc# ',
    PERMISSION_DENIED: 'https://shimo.im/docs/N6BsKQBMPhsSvRDA',
    DEVICES_NOT_FOUND: 'https://shimo.im/docs/kCvCRp9VG63wr3gg',
    default: 'https://shimo.im/docs/vrjhq3yJ6W6kVkgj'
  }

  window.open(helpLink[errorCode] || helpLink.default)
}

export function getCameraErrorText(errorCode) {
  const errorText = {
    NotAllowedError: '未获取到摄像头权限',
    MEDIA_OPTION_INVALID: '摄像头被占用或者分辨率不支持',
    DEVICES_NOT_FOUND: '没有找到设备',
    NOT_SUPPORTED: '浏览器不支持获取获取摄像头和麦克风',
    PERMISSION_DENIED: '浏览器禁用设备或者用户拒绝打开设备',
    CONSTRAINT_NOT_SATISFIED: '配置参数不合法',
    UNDEFINED: '摄像头打开失败',
    default: '摄像头打开失败'
  }

  return errorText[errorCode] || errorText.default
}
